var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12750",
    "data-name": "Group 12750",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3781",
    "data-name": "Rectangle 3781",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12750-2",
    "data-name": "Group 12750",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11292",
    "data-name": "Path 11292",
    d: "M21.027,31.685H8.425A1.629,1.629,0,0,1,6.8,30.058v-18.9A1.629,1.629,0,0,1,8.425,9.528h2.1v1.154h-2.1a.474.474,0,0,0-.473.474v18.9a.474.474,0,0,0,.473.473h12.6Z",
    transform: "translate(-2.876 -4.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M38.828,16.93H37.675V11.155a.474.474,0,0,0-.473-.474H35.1V9.527h2.1a1.63,1.63,0,0,1,1.627,1.627Z",
    transform: "translate(-14.85 -4.031)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M22.567,31.124H11.016a.577.577,0,0,1-.577-.577v-16.8a.577.577,0,0,1,.577-.577h1.049v1.154h-.472V29.97H22.567Z",
    transform: "translate(-4.417 -5.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M36.728,18.47H35.574V14.322H35.1V13.168h1.05a.577.577,0,0,1,.577.577Z",
    transform: "translate(-14.85 -5.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M25.157,10.472h-10.5a.576.576,0,0,1-.577-.577V8.32A2.155,2.155,0,0,1,16.23,6.168h1.061a2.678,2.678,0,0,1,5.23,0h1.061A2.155,2.155,0,0,1,25.734,8.32V9.895a.576.576,0,0,1-.577.577M15.232,9.318H24.58v-1a1,1,0,0,0-1-1H22.006a.577.577,0,0,1-.577-.577,1.523,1.523,0,0,0-3.047,0,.577.577,0,0,1-.577.577H16.23a1,1,0,0,0-1,1Z",
    transform: "translate(-5.956 -1.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3777",
    "data-name": "Rectangle 3777",
    width: 1.154,
    height: 1.05,
    transform: "translate(13.373 5.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M34.713,32.6a4.253,4.253,0,1,1,4.253-4.253A4.257,4.257,0,0,1,34.713,32.6m0-7.351a3.1,3.1,0,1,0,3.1,3.1,3.1,3.1,0,0,0-3.1-3.1",
    transform: "translate(-12.887 -10.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M37.969,43.274a.577.577,0,0,1-.408-.169l-1.693-1.692-1.692,1.692a.577.577,0,0,1-.985-.408V36.922h1.154V41.3l1.115-1.115a.594.594,0,0,1,.816,0L37.392,41.3V36.922h1.154V42.7a.576.576,0,0,1-.577.577",
    transform: "translate(-14.043 -15.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M16.74,22.568a.575.575,0,0,1-.408-.169l-1.05-1.05.816-.816.594.594L18.389,19l.9.721-2.1,2.626a.577.577,0,0,1-.418.216H16.74",
    transform: "translate(-6.465 -8.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M16.74,29.848a.576.576,0,0,1-.408-.169l-1.05-1.05.816-.816.594.594,1.7-2.122.9.721-2.1,2.626a.577.577,0,0,1-.418.216H16.74",
    transform: "translate(-6.465 -11.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M16.74,37.13a.575.575,0,0,1-.408-.169l-1.05-1.05.816-.816.594.594,1.7-2.122.9.721-2.1,2.626a.577.577,0,0,1-.418.216H16.74",
    transform: "translate(-6.465 -14.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3778",
    "data-name": "Rectangle 3778",
    width: 3.151,
    height: 1.154,
    transform: "translate(14.475 11.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3779",
    "data-name": "Rectangle 3779",
    width: 1.575,
    height: 1.154,
    transform: "translate(14.475 15.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3780",
    "data-name": "Rectangle 3780",
    width: 1.575,
    height: 1.154,
    transform: "translate(14.475 20.199)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationActive);
export default __webpack_public_path__ + "static/media/verification_active.4b46e9a25bcd95f7ee4805b2fd9c0f80.svg";
export { ForwardRef as ReactComponent };